import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Protege as rotas da área do cliente (/app/*).
 * - loading → spinner
 * - sem sessão → /auth
 * - user de org (não-consumer) → /painel (não pertence aqui)
 * - consumer → renderiza
 */
export function ConsumerProtectedRoute({ children }: { children: ReactNode }) {
  const { user, isLoading, isConsumer } = useAuthContext();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (!isConsumer) {
    return <Navigate to="/painel" replace />;
  }

  return <>{children}</>;
}
